import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllAlteracaoRequisicaoCompraProdutoServicoUseCase } from "../../../presentation/useCases/read/get_all_alteracao_requisicao_compra_produto_servico_use_case";
import { AlteracaoRequisicaoProdutoServico } from "../../models/alteracao_requisicao_produto_servico";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetAllAlteracaoRequisicaoCompraProdutoServicoUseCase
 */

export class GetAllAlteracaoRequisicaoCompraProdutoServicoUseCase
  extends BasePaginatedUseCase<AlteracaoRequisicaoProdutoServico>
  implements IGetAllAlteracaoRequisicaoCompraProdutoServicoUseCase {
  constructor(private readonly repository: IComprasRepository) {
    super();
  }

  async getAllAlteracaoRequisicaoCompraProdutoServico(
    idRequisicaoCompra: number | undefined,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idRequisicaoCompra === undefined) throw new Error('Falha ao buscar id da requisição de compra!');

    const response = await this.repository.getAllAlteracaoRequisicaoCompraProdutoServico(
      idRequisicaoCompra,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
